// import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
import React from 'react';
import SessionRow from './SessionRow';
import PropTypes from 'prop-types';

// const useRowStyles = makeStyles({
//   root: {
//     '& > *': {
//       borderBottom: 'unset',
//     },
//   },
// });

Row.propTypes = {
  sessions: PropTypes.object,
};

export default function Row(props) {
  const { sessions } = props;
  // const classes = useRowStyles();

  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Title</TableCell>
              <TableCell align="right">Status</TableCell>
              <TableCell align="right">Id</TableCell>
              <TableCell align="right">Resource Id</TableCell>
              <TableCell align="right">Help Requests</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sessions?.length < 1 && (
              <div style={{ width: '100%', padding: '2rem', textAlign: 'center' }}>
                No Live Sessions
              </div>
            )}
            {sessions?.map((row) => (
              <SessionRow key={row.SessionId} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
